import * as React from 'react';
// @ts-ignore
import { Organization } from '../types';
import OrganizationPickerView from './OrganizationPickerView';
import * as OrganizationPickerActions from 'components/OrganizationPicker/OrganizationPickerActions';
import LoadingIndicator from 'components/LoadingIndicator';

type Props = {
  onChange?: (organization?: Organization) => void;
  onError?: (e: any) => void;
  onClickInteraction?: () => void;
  initialOrganizationUuid?: string;
  permanentItem?: any;
  permanentItemOnClick?: () => void;
};

type State = {
  loadingInitialOrganization: boolean;
  initialOrganization?: Organization;
};

export default class OrganizationPickerContainer extends React.Component<Props, State> {
  state: State = {
    loadingInitialOrganization: false,
  };

  componentDidMount() {
    if (this.props.initialOrganizationUuid) {
      this.setState({loadingInitialOrganization: true });
      OrganizationPickerActions.organizationPickerInitial(this.props.initialOrganizationUuid).then((resp) => {
        if(resp.success) {
          this.setState({ initialOrganization: resp.organization, loadingInitialOrganization: false });
        } else {
          this.onError(resp.errorMessage);
          console.error(resp.errorMessage);
        }
      }).catch(e => {
        console.error(e);
      });
    }
  }

  async onQueryChange(input: string): Promise<Organization[]> {
    const resp = await OrganizationPickerActions.findOrganizationsByName(input);
    if (resp.success) {
      return resp.organizations
    } else {
      this.onError(resp.errorMessage);
      return [];
    }
  }

  onError(e: any) {
    this.props.onError && this.props.onError(e);
  }

  render() {
    const { loadingInitialOrganization, initialOrganization } = this.state;
    return loadingInitialOrganization ?
      <LoadingIndicator /> :
      <OrganizationPickerView
        {...this.props}
        onQueryChange={this.onQueryChange}
        initialOrganization={initialOrganization} />;
  }
}
